import searchcontext from "../Configurations/searchContext.json";

export function populateSearchCriteria(props) {
    let searchCriteria = {};
    searchCriteria.context = { runAsUser: process.env.REACT_APP_API_USER_ID }
    let defaultCriteria = searchcontext.criteria;
    let searchFields = [];
    let formData = props.searchCriteria;
 
    if (formData.selectedReportCategory) {
        let value = formData.selectedReportCategory.CatogeryType;

        // TODO: also translate the other document types here (should be parameterized, or come in as an ID on the dropdown item.)
        switch(formData.selectedReportCategory.CatogeryType) {
            case 'SDS':
                value = 'SDS,MSDS,PRDVEND';
                break;
            case "AIS":
                value = "AIS";
                break;
            case "DGW":
                value = "DGW";
                break;
        }

        searchFields.push({ value: value, field: "DOCUMENTTYPE", valueArray: [] });
    }
    else
    {
        searchFields.push({ value: 'SDS,MSDS,PRDVEND,AIS,DGW', field: "DOCUMENTTYPE", valueArray: [] });
    }

    // set paging information...
    searchFields.push({ value: props.dataState.skip.toString(), field: "PAGING_SKIP", valueArray: [] });
    searchFields.push({ value: props.dataState.take.toString(), field: "RESULTSPERPAGE", valueArray: [] });

    if (formData.selectedLanguage) {
        searchFields.push({ value: formData.selectedLanguage.Id, field: "DOCUMENTLANGUAGECODE", valueArray: [] });
    }

    if (formData.selectedCountry) {
        searchFields.push({ value: formData.selectedCountry.Id, field: "DOCUMENTCOUNTRY", valueArray: [] });
    }

    if (formData.categoryValue) {
        searchFields.push({ value: formData.categoryValue, field: "PRODUCTIDENTITY", valueArray: []});
    }

    if (formData.productName && formData.productName.length > 0) {
        // TODO: should potentially put * between all words in the search parameter.
        //let productName = { value: '*' + formData.productName + '*', field: "PRODUCTNAME", valueArray:[] };
         let productName_keywords = formData.productName.split(' ');
         productName_keywords.map((x,index) => {
            productName_keywords[index] = "*" + productName_keywords[index]+"*";
         })
         productName_keywords = productName_keywords.join('<AND>').toString();
         let productName = {value: productName_keywords, field:"PRODUCTNAME", valueArray:[]}
        searchFields.push(productName);
    }

    searchCriteria.criteria = searchFields.concat(defaultCriteria);
    return searchCriteria;
}